import { useMemo } from 'react';

import type { PreloadedSearchPayload } from './preloadSearch.ts';

export const usePreloadDataProvider = (): {
	getPreloadedSearch: ({ cloudId }: { cloudId: string }) => PreloadedSearchPayload | null;
	clearPreloadedSearch: ({ cloudId }: { cloudId: string }) => void;
} => {
	return useMemo(
		() => ({
			getPreloadedSearch: ({ cloudId }: { cloudId: string }): PreloadedSearchPayload | null => {
				// The payload is returned regardless of route transition state, and remains
				// readable until it is explicitly cleared. Both matter for the Quick Find async
				// preload: a Quick Find→search-page navigation is a client-side transition, so
				// bailing out during transitions would discard the payload Quick Find just
				// warmed. The consumer (search-page) owns clearing it at the right time.
				const preloadedSearch = window.__PRELOADED_SEARCH__;

				if (!preloadedSearch || preloadedSearch.cloudId !== cloudId) {
					return null;
				}

				return preloadedSearch as PreloadedSearchPayload;
			},
			clearPreloadedSearch: ({ cloudId }: { cloudId: string }) => {
				const preloadedSearch = window.__PRELOADED_SEARCH__;

				// Destructive by design: freeing the global stops any consumer that bypasses
				// this provider from reading stale data, and lets Quick Find re-warm it on the
				// next search-page transition.
				if (preloadedSearch?.cloudId === cloudId) {
					window.__PRELOADED_SEARCH__ = undefined;
				}
			},
		}),
		[],
	);
};
